import {createGlobalStyle} from 'styled-components';

import {PopperClassName} from '@famly/mf_data-display_popper';
import {SIDEBAR_Z_INDEX} from 'web-app/react/navigation-v2/sidebar/constants';

export const GlobalStyleModernFamly = createGlobalStyle`
    .${PopperClassName} {
        z-index: ${SIDEBAR_Z_INDEX + 1}
    }
`;
